import { render, staticRenderFns } from "./StudentsImport.vue?vue&type=template&id=2bad23d1&scoped=true&"
import script from "./StudentsImport.vue?vue&type=script&lang=ts&"
export * from "./StudentsImport.vue?vue&type=script&lang=ts&"
import style0 from "./StudentsImport.vue?vue&type=style&index=0&id=2bad23d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad23d1",
  null
  
)

export default component.exports